import { render, staticRenderFns } from "./KioskSubscription.vue?vue&type=template&id=5f5c450a"
import script from "./KioskSubscription.vue?vue&type=script&lang=ts"
export * from "./KioskSubscription.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports